import { Component, Output, EventEmitter } from '@angular/core';
import * as firebase from 'firebase';
import { FirebaseCmsService } from './../../providers/firebase-cms.service';
import { Form } from '@angular/forms';


@Component({
    selector: 'app-cms-category',
    template: `<h2>Category Management</h2>

Category ID: <input><button>Create a Category</button>`
})
export class CategoryComponent {


    constructor(
        public cms: FirebaseCmsService
    ) {
        
    }

    

}
